import { 
  FETCH_FONTS_REQUEST, FETCHING_FONTS_SUCCEEDED, FETCHING_FONTS_FAILED,
  INITIATE_FONT_UPLOAD, UPDATE_FONT_UPLOAD_PROGRESS, 
  INSTALL_FONTS, UNINSTALL_FONTS, ASSOCIATE_FONTS_WITH_WIDGET, INVALIDATE_FONT_UPLOAD_ERROR,
  UPLOAD_FONT_REQUEST, UPLOADING_FONT_SUCCEEDED, UPLOADING_FONT_FAILED,
  DELETE_FONT_REQUEST, DELETING_FONT_SUCCEEDED, DELETING_FONT_FAILED
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import BuildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const FONT_URL = `${apiUrl}/api/2.0/fonts`;

export const fetchFonts = createAction(FETCH_FONTS_REQUEST);

const fetchingFontsSucceeded = createAction(FETCHING_FONTS_SUCCEEDED, (response) => {
  return response;
})

const fetchingFontsFailed = createAction(FETCHING_FONTS_FAILED, (error) => {
  return error;
});

function* fetchFontsSaga(action) {
  const fetchFontsAPI = () => {
    return axios.get(FONT_URL).then(response => response.data);
  }

  try {
    const response = yield call(fetchFontsAPI);
    yield put(fetchingFontsSucceeded(response));
  } catch (error) {
    yield put(fetchingFontsFailed(error));
  }
}

/**
 * Create Font
*/
export const initiateFontUpload = createAction(INITIATE_FONT_UPLOAD, (request) => {
  return request;
});

export const updateFontUploadProgress = createAction(UPDATE_FONT_UPLOAD_PROGRESS, (id, progress) => {
  return {id, progress};
});

export const uploadFont = createAction(UPLOAD_FONT_REQUEST, (id, request) => {
  return {id, request};
})

export const uploadingFontSucceeded = createAction(UPLOADING_FONT_SUCCEEDED, (id, response) => {
  return {id, response};
})

export const uploadingFontFailed = createAction(UPLOADING_FONT_FAILED, (id, error) => {
  return {id, error};
})

function* uploadFontSaga(action) {
  const {id, request} = action.payload;

  const uploadFontAPI = () => {
    return axios.post(FONT_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(uploadFontAPI);
    if (response) {
      yield put(uploadingFontSucceeded(id, response));
    }
  } catch (error) {
    yield put(uploadingFontFailed(id, error));
  }
}

/**
 * Delete Font
 * 
*/
export const deleteFont = createAction(DELETE_FONT_REQUEST, (id) => {
  return id;
})

export const deletingFontSucceeded = createAction(DELETING_FONT_SUCCEEDED, (id) => {
  return id;
})

export const deletingFontFailed = createAction(DELETING_FONT_FAILED, (id, error) => {
  return {id, error};
})

function* deleteFontSaga(action) {
  const id = action.payload;

  const url = BuildUrl(FONT_URL, {
    path: `/${id}`
  });

  const deleteFontAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deleteFontAPI);
    yield put(deletingFontSucceeded(id));
  } catch (error) {
    yield put(deletingFontFailed(id, error));
  }
}

export const invalidateFontUploadError = createAction(INVALIDATE_FONT_UPLOAD_ERROR);

export const installFonts = createAction(INSTALL_FONTS, (fonts) => {
  return fonts;
});

export const uninstallFonts = createAction(UNINSTALL_FONTS, (fonts) => {
  return fonts;
});

export const associateFontsWithWigdet = createAction(ASSOCIATE_FONTS_WITH_WIDGET, (editorSession, widget, fonts) => {
  return {editorSession, widget, fonts};
});

export default function* fontsSaga() {
  yield takeEvery(FETCH_FONTS_REQUEST, fetchFontsSaga);
  yield takeEvery(UPLOAD_FONT_REQUEST, uploadFontSaga);
  yield takeEvery(DELETE_FONT_REQUEST, deleteFontSaga);
}